document.addEventListener('DOMContentLoaded', function () {
  const tiles = document.querySelectorAll('.category-tile');
  const details = document.querySelectorAll('.tile-details');

  function fetchAndRenderVideos(tile, detail) {
    const category = tile.getAttribute('data-video-category') || tile.querySelector('.tile-title').textContent.trim();
    const videoContainer = detail.querySelector(".video-content");

    if (videoContainer) {
      videoContainer.innerHTML = `<em>Loading Videos for ${category}</em>`;
      fetch(`/apps/greenworks/support-hub?category=${encodeURIComponent(category)}`)
        .then((res) => res.json())
        .then((data) => {
          const nodes = data?.response?.metaobjects?.nodes || [];
          if (!Array.isArray(nodes) || nodes.length === 0) {
            videoContainer.innerHTML = `<em>No videos found for ${category}.</em>`;
            return;
          }

          // Render video grid
          videoContainer.innerHTML = `
            <div class="video-thumbnails-grid">
              ${nodes
                .map((node) => {
                  const titleField = node.fields.find(
                    (f) => f.key === "title"
                  );
                  const youtubeField = node.fields.find(
                    (f) => f.key === "youtube_key"
                  );
                  const coverField = node.fields.find(
                    (f) => f.key === "cover_image_upload"
                  );
                  const title = titleField?.value || "Product Video";
                  const youtubeKey = youtubeField?.value;
                  // Get cover image from image.url (from loader), fallback to youtube
                  const coverImg =
                    coverField?.reference?.image?.url ||
                    (youtubeKey
                      ? `https://img.youtube.com/vi/${youtubeKey}/hqdefault.jpg`
                      : "");
                  return youtubeKey
                    ? `
                    <div class="flex flex-col product__video-card relative" data-url="https://www.youtube.com/embed/${youtubeKey}?autoplay=1">
                      <div class="youtube-thumb" data-youtube-id="${youtubeKey}" tabindex="0" aria-label="Play ${title}">
                        <img src="${coverImg}" alt="Video cover for ${title}" loading="lazy" />
                        <button class="play-btn" aria-label="Play video for ${title}">▶</button>
                      </div>
                         <h5 class="video-title text-body-large">${title}</h5>
                      </div>
                    `
                    : "";
                })
                .join("")}
            </div>
          `;   
        }).catch((err) => {
          videoContainer.innerHTML = `<em>Error loading videos.</em>`;
        });
    }
  }

  // Attach click handlers
  tiles.forEach((tile, idx) => {
    tile.addEventListener('click', (e) => {
      if (e.currentTarget !== e.target && !e.target.closest('.category-tile')) return;
      
      tiles.forEach(t => t.classList.remove('active'));
      tile.classList.add('active');
      
      details.forEach((d, i) => {
        if (i === idx) {
          d.removeAttribute('hidden');
          tile.setAttribute('aria-expanded', 'true');
          tile.scrollIntoView({ behavior: "smooth", block: "center" });
          fetchAndRenderVideos(tile, d); // Fetch videos on click!
        } else {
          d.setAttribute('hidden', '');
          tiles[i].setAttribute('aria-expanded', 'false');
        }
      });
    });
  });

  // --- Fetch for the first tile videos on load ---
  if (tiles.length && details.length) {
    fetchAndRenderVideos(tiles[0], details[0]);
  }
});
